import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

import exodus from '@/ui/exodus';
import selectors from '@/ui/flux/selectors';
import type { Nft } from '@/ui/types';

const useClaimedPlaygroundSbt = (): {
  loading: boolean;
  data?: Nft;
} => {
  const [loading, setLoading] = useState(true);

  const data = useSelector(selectors.playgroundSbt.claimed);

  useEffect(() => {
    exodus.playgroundSbt.refresh().then(() => {
      setLoading(false);
    });
  }, []);

  return { loading, data };
};

export default useClaimedPlaygroundSbt;
